/*
 * @Author: WangChao
 * @Date: 2025-12-18 21:05:03
 * @LastEditors: WangChao
 * @LastEditTime: 2026-04-09 15:12:41
 * @FilePath: \travel_ai\src\store\modules\chat\index.js
 * @Description:
 */
const http = require("@/lib/http")["default"];
const api = require("@/lib/api");
import Vue from "vue";
import { state, mutations } from "./additional";

export default {
  namespaced: true,
  state: {
    flightKeepArray: [],
    travelData: {},
    thoughtFlight: {}, // 机票思考流数据就绪
    loading: false, // 全屏loading
    loadingTip: "", // 全屏loading提示
    historyData: [], // 历史消息
    bookingData: null, // 二级路由页下单存储参数
    hotelCompareList: [], // 酒店对比集合
    ...state,
    billCode: "",
    endChat: false,
    fromWhere: "",
  },
  mutations: {
    ...mutations,
    setFlightKeepArray(state, val) {
      state.flightKeepArray = val;
    },
    setTravelData(state, obj) {
      state.travelData = obj;
    },
    setThoughtFlight(state, index) {
      Vue.set(state.thoughtFlight, index, true);
    },
    setLogin(state, payload) {
      let { resolve, reject, res } = payload;
      if (res && res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    },
    fetchCompany(state, payload) {
      let { resolve, reject, res } = payload;
      if (res && res.Code === 'SUCCESS') {
        resolve(res);
      } else {
        reject(res);
      }
    },
    setHunterHotel(state, payload) {
      let { resolve, reject, res } = payload;
      if (res && res.success) {
        resolve(res);
      } else {
        reject(res);
      }
    },
    setLoading(state, val) {
      if (typeof val === "boolean") {
        state.loading = val;
        state.loadingTip = "";
      } else {
        const { loading, tip } = val;
        state.loading = loading;
        state.loadingTip = tip;
      }
    },
    setHistoryData(state, val) {
      state.historyData = val;
    },
    setBookingData(state, val) {
      state.bookingData = val;
    },
    setHotelCompare(state, val) {
      state.hotelCompareList = val;
    },
    setBillCode(state, val) {
      state.billCode = val;
    },
    setEndChat(state, val) {
      state.endChat = val;
    },
    setFromWhere(state, val) {
      state.fromWhere = val;
    }
  },
  actions: {
    setFlightKeepArray({ commit }, val) {
      commit("setFlightKeepArray", val);
    },
    fetchSsoLogin({ commit }, args) {
      const { params } = args;
      return http.postJSON(api.chat.ssoLogin, params).then((res) => {
        commit("setLogin", { res, ...args });
      });
    },
    fetchCompanyList({ commit }, args) {
      const { params } = args;
      return http.postJSON(api.chat.searchCompany, params).then((res) => {
        commit("fetchCompany", { res, ...args });
      });
    },
    getHunterHotel({ commit }, args) {
      const { params } = args;
      return http.get(api.chat.getHunterHotel, params).then((res) => {
        commit("setHunterHotel", { res, ...args });
      });
    }
  }
};
